@import ../../../styles/helpers

.container
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    gap: 10px